module.exports = __webpack_public_path__ + "media/images/voice13-2-9fa00011375a0400136341211116e7c1.jpg";